<template>
  <div class="all-results">
    <div class="qbcgBgDiv">
    <img src="../../../assets/qbcgBg.png" class="qbcgBg"/>
    </div>

    <div class="allResultsDiv">
      
<div class="resultTitleDiv">
<div class="resultTitle">申报名称</div>
<div class="resultTitle">成果申报单位</div>
</div>
<div v-if="homeProjectData.length>0">
<div class="resultContentDiv" v-for="item in homeProjectData" :key="item.id">
<div class="resultContentText">{{item.name}}</div>
<div class="resultContentText">{{item.org_name}}</div>
</div>
</div>

    <div style="display: flex;justify-content: center;margin-top: 40px;" v-else>
    <img src="../../../assets/empit.png" class="empitImg" />
    </div>
        <div class="pageBox" v-if="homeProjectData.length>0">
        <el-pagination @size-change="sizePagination" :page-sizes="[9, 30, 50, 100]" @current-change="currentPagination" :page-size="form.pageSize"
          background layout="prev, pager, next,sizes" :total="projectTotal">
        </el-pagination>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "AllResults",
  props: {

  },
  data() {
    return {
            form: {
        currPage: 1,
        pageSize: 9,
      },
      homeProjectData:[],
      projectTotal:0,
      searchKeyword: ""
    };
  },
  mounted(){
    this.form.game_id = this.$route.query.id;
    this.getTableList()
  },
  methods: {
    sizePagination(e) {
      this.form.pageSize = e;
      this.getTableList();
    },
    currentPagination(e) {
      this.form.currPage = e;
      this.getTableList();
    },
        async getTableList() {
      try {
        this.$API.getHomeProject(this.form).then((res) => {
          this.homeProjectData = res.data.list;
          this.projectTotal = res.data.pageInfo.allRows;
        });
      } catch (error) {
        console.error("获取列表数据失败:", error);
      } finally {
        this.loading = false;
      }
    },
  }
};
</script>

<style scoped>
.empitImg{
  width: 200px;
  height: 200px;
}
.resultContentText{
font-family: Microsoft YaHei, Microsoft YaHei;
font-weight: 400;
font-size: 16px;
color: #5E6A7A;

}
.resultContentDiv{
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #E2E2E2;
  padding: 25px 0;
  cursor: pointer;
}
.resultTitleDiv{
  display: flex;
  justify-content: space-between;
}
.resultTitle{
font-family: Microsoft YaHei, Microsoft YaHei;
font-weight: bold;
font-size: 16px;
color: #444444;

}
.allResultsDiv{
  width: 100%;
  background: #E8F4FF;
  border-radius: 4px;
  padding: 20px;
  margin-bottom: 30px;
  min-height: 400px;
}
.qbcgBg{
  width: 400px;
  height: 72px;
  margin-top: 50px;
  margin-bottom: 30px;
}
.qbcgBgDiv{
  display: flex;
  justify-content: center;
}
.pageBox {
  width: 100%;
  display: flex;
  justify-content: end;
  cursor: pointer;
  margin-bottom: 30px;
  margin-top: 30px;
}
.all-results{

}
</style>
